module.exports = __webpack_public_path__ + "static/media/top-sp.3fab333.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-sp.mp4
// module id = RVO7
// module chunks = 0